// Recovered compiled webpack factory 47434. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { R: () => l, e: () => s });
  var n = r(61571),
    a = r(43275),
    o = r(35868);
  function i(e) {
    a.Yz.log(`Ignoring span ${e.op} - ${e.description} because it matches \`ignoreSpans\`.`);
  }
  function s(e, t) {
    if (!t?.length || !e.description) return !1;
    for (let a of t) {
      var r;
      if ("string" == typeof (r = a) || r instanceof RegExp) {
        if ((0, o._c)(e.description, a)) return (n.T && i(e), !0);
        continue;
      }
      if (!a.name && !a.op) continue;
      let t = !a.name || (0, o._c)(e.description, a.name),
        s = !a.op || (e.op && (0, o._c)(e.op, a.op));
      if (t && s) return (n.T && i(e), !0);
    }
    return !1;
  }
  function l(e, t) {
    let r = t.parent_span_id,
      n = t.span_id;
    if (r) for (let t of e) t.parent_span_id === n && (t.parent_span_id = r);
  }
}
